import { defineComponent } from "vue";
import Svg from "../../core/svg";
import { VueProp } from "../../core/vueHelpers";
import { Classes } from "../classes";
import { ModuleMenuScreenData } from "../menuData";

export default /*#__PURE__*/ defineComponent(
{
    name: "menuNewWindowButton",
    props:
    {
        moduleMenuScreenData: VueProp<ModuleMenuScreenData>(),
        iconClass: VueProp(String)
    },
    render()
    {
        return (
            <a
                class={Classes.moduleScreensNewWindowButton}
                aria-label={"Go to " + this.moduleMenuScreenData.displayText + " in a new window"}
                href="javascript:void(0)"
                data-target="popout"
                role="none"
            >
                <Svg class={this.iconClass} name="NewWindow" />
            </a>
        );
    }
});